import React from 'react';
import { format, addDays, subDays, isToday } from 'date-fns';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const WorkoutNavigationHeader = ({
  currentDate,
  onPrevWorkout,
  onNextWorkout,
  onNavigateToToday,
  hasPrevWorkout,
  hasNextWorkout,
  hasTodayWorkout
}) => {
  const isCurrentDay = isToday(currentDate);

  return (
    <div className="flex items-center justify-between w-full px-3 sm:px-4 py-2 bg-gray-800 rounded-xl mb-4">
      {/* LEFT: Previous Workout Button */}
      <button
        onClick={onPrevWorkout}
        disabled={!hasPrevWorkout}
        className={`min-w-[44px] min-h-[44px] flex items-center justify-center rounded-full transition-colors active:scale-95 ${
          hasPrevWorkout
            ? 'text-gray-400 hover:bg-gray-700 hover:text-white'
            : 'text-gray-600 cursor-not-allowed'
        }`}
        aria-label="Previous workout"
      >
        <ChevronLeftIcon className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>

      {/* CENTER: Clickable Date (PERFECTLY CENTERED) */}
      <div 
        onClick={isCurrentDay ? undefined : (hasTodayWorkout ? onNavigateToToday : undefined)}
        className={`flex-1 flex flex-col items-center justify-center ${
          isCurrentDay 
            ? 'text-white cursor-default' 
            : hasTodayWorkout
            ? 'text-gray-300 hover:text-blue-300 cursor-pointer transition-colors'
            : 'text-gray-400 cursor-default'
        }`}
        aria-label={
          isCurrentDay 
            ? "Current workout" 
            : hasTodayWorkout 
            ? "Click to view today's workout"
            : "Today has no scheduled workout"
        }
      >
        <h2 className="text-base sm:text-lg font-semibold text-center">
          {format(currentDate, 'MMMM d, EEEE')}
        </h2>
        {!isCurrentDay && hasTodayWorkout && (
          <p className="text-xs text-gray-500 hover:text-blue-400 transition-colors text-center mt-1">
            Click to view today
          </p>
        )}
      </div>

      {/* RIGHT: Next Workout Button */}
      <button
        onClick={onNextWorkout}
        disabled={!hasNextWorkout}
        className={`min-w-[44px] min-h-[44px] flex items-center justify-center rounded-full transition-colors active:scale-95 ${
          hasNextWorkout
            ? 'text-gray-400 hover:bg-gray-700 hover:text-white'
            : 'text-gray-600 cursor-not-allowed'
        }`}
        aria-label="Next workout"
      >
        <ChevronRightIcon className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>
    </div>
  );
};

export default WorkoutNavigationHeader;
